module.exports = __webpack_public_path__ + "icons/original/small/small-c4.bc367c0d574d1037f7983b61b94776bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/small/small-c4.png
// module id = 90E6
// module chunks = app